import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import useSearchParams from 'hooks/useSearchParams';
import toNumber from 'utils/toNumber';

/**
 * Hook providing the value of a single search query parameter,
 * as well as a setter to update it.
 *
 * If the return value can be cast to a number, it will be.
 */

function useSearchParameter(parameterName) {
  var _useSearchParams = useSearchParams(),
    _useSearchParams2 = _slicedToArray(_useSearchParams, 2),
    value = _useSearchParams2[0][parameterName],
    setSearchParams = _useSearchParams2[1];
  function changeValue(newValue) {
    setSearchParams(_defineProperty({}, parameterName, newValue));
  }
  return [toNumber(value), changeValue];
}
export default useSearchParameter;